import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  setVideoResolutionDisplay,
  navViewMedia,
  navCloseMedia,
} from 'redux/actions'
import {
  selectedTripMedia,
  selectedTripData,
  videoResolutionDisplay,
} from 'redux/reducers'

import Component from './component'

const mapStateToProps = state => ({
  tripMedia: selectedTripMedia(state),
  tripData: selectedTripData(state),
  videoResolutionDisplay: videoResolutionDisplay(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setVideoResolutionDisplay,
      navViewMedia,
      navCloseMedia,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/MediaModal/index.js